var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCancel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.5,
    height: 15.5,
    viewBox: "0 0 15.5 15.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "cancel",
    d: "M2.5-11.469A7.5,7.5,0,0,1,8-13.75a7.47,7.47,0,0,1,5.484,2.266A7.47,7.47,0,0,1,15.75-6,7.47,7.47,0,0,1,13.484-.516,7.47,7.47,0,0,1,8,1.75,7.47,7.47,0,0,1,2.516-.516,7.47,7.47,0,0,1,.25-6,7.445,7.445,0,0,1,2.5-11.469ZM14.25-6.312a6.07,6.07,0,0,0-1.828-4.109A6.054,6.054,0,0,0,8.328-12.25a5.85,5.85,0,0,0-4.172,1.344l8.75,8.75A5.827,5.827,0,0,0,14.25-6.312Zm-12.5.656A6.038,6.038,0,0,0,3.578-1.578,6.054,6.054,0,0,0,7.672.25a5.85,5.85,0,0,0,4.172-1.344l-8.75-8.75A5.873,5.873,0,0,0,1.75-5.656Z",
    transform: "translate(-0.25 13.75)",
    fill: "#0a0a0a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancel);
export default __webpack_public_path__ + "static/media/cancel.fc5d2a9b21a01ef558ab21a91999a89f.svg";
export { ForwardRef as ReactComponent };